// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__16GKC","footer":"ModalFilter_footer__3dFpH"};